import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fa0d63b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2fa0d63b&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa0d63b')) {
      api.createRecord('2fa0d63b', component.options)
    } else {
      api.reload('2fa0d63b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fa0d63b", function () {
      api.rerender('2fa0d63b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/matchmakerRechargePosition/list/index.vue"
export default component.exports